var _classCallCheck = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _assertThisInitialized = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var Base = require('./Base');

var AdUnit = require('./AdUnit');

var AdSlot = /*#__PURE__*/function (_Base) {
  "use strict";

  _inherits(AdSlot, _Base);

  var _super = _createSuper(AdSlot);

  function AdSlot() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$id = _ref.id,
        id = _ref$id === void 0 ? '' : _ref$id,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? '' : _ref$type,
        _ref$tags = _ref.tags,
        tags = _ref$tags === void 0 ? [] : _ref$tags,
        _ref$autoTags = _ref.autoTags,
        autoTags = _ref$autoTags === void 0 ? [] : _ref$autoTags,
        _ref$owner = _ref.owner,
        owner = _ref$owner === void 0 ? '' : _ref$owner,
        _ref$created = _ref.created,
        created = _ref$created === void 0 ? null : _ref$created,
        _ref$ipfs = _ref.ipfs,
        ipfs = _ref$ipfs === void 0 ? '' : _ref$ipfs,
        _ref$title = _ref.title,
        title = _ref$title === void 0 ? '' : _ref$title,
        _ref$description = _ref.description,
        description = _ref$description === void 0 ? '' : _ref$description,
        _ref$fallbackUnit = _ref.fallbackUnit,
        fallbackUnit = _ref$fallbackUnit === void 0 ? null : _ref$fallbackUnit,
        _ref$mediaUrl = _ref.mediaUrl,
        mediaUrl = _ref$mediaUrl === void 0 ? '' : _ref$mediaUrl,
        _ref$mediaMime = _ref.mediaMime,
        mediaMime = _ref$mediaMime === void 0 ? '' : _ref$mediaMime,
        _ref$targetUrl = _ref.targetUrl,
        targetUrl = _ref$targetUrl === void 0 ? '' : _ref$targetUrl,
        _ref$rules = _ref.rules,
        rules = _ref$rules === void 0 ? null : _ref$rules,
        _ref$rulesInput = _ref.rulesInput,
        rulesInput = _ref$rulesInput === void 0 ? null : _ref$rulesInput,
        _ref$minPerImpression = _ref.minPerImpression,
        minPerImpression = _ref$minPerImpression === void 0 ? null : _ref$minPerImpression,
        _ref$website = _ref.website,
        website = _ref$website === void 0 ? '' : _ref$website,
        _ref$archived = _ref.archived,
        archived = _ref$archived === void 0 ? false : _ref$archived,
        _ref$modified = _ref.modified,
        modified = _ref$modified === void 0 ? null : _ref$modified,
        _ref$temp = _ref.temp,
        temp = _ref$temp === void 0 ? {} : _ref$temp,
        _ref$status = _ref.status,
        status = _ref$status === void 0 ? {} : _ref$status;

    _classCallCheck(this, AdSlot);

    _this = _super.call(this);
    _this.id = id || ipfs; // Spec props

    _this.type = type;
    _this.tags = tags;
    _this.autoTags = autoTags;
    _this.owner = owner;
    _this.created = created; // Non spec props

    _this.ipfs = ipfs;
    _this.title = title;
    _this.description = description;
    _this.fallbackUnit = fallbackUnit;
    _this.rules = rules;
    _this.rulesInput = rulesInput;
    _this.minPerImpression = minPerImpression;
    _this.website = website;
    _this.archived = archived;
    _this.modified = modified; // Platform related props

    _this.temp = temp;
    _this.status = status; // Used for easier fallback unit creation

    _this.mediaUrl = mediaUrl;
    _this.mediaMime = mediaMime;
    _this.targetUrl = targetUrl;
    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(AdSlot, [{
    key: "adUrl",
    get: function get() {
      return this.targetUrl;
    }
  }, {
    key: "spec",
    get: function get() {
      return this.deepCopyObj({
        type: this.type,
        tags: this.tags,
        autoTags: this.autoTags,
        owner: this.owner,
        created: this.created
      });
    }
  }, {
    key: "marketAdd",
    get: function get() {
      return this.deepCopyObj({
        type: this.type,
        tags: this.tags,
        title: this.title,
        description: this.description,
        fallbackUnit: this.fallbackUnit,
        minPerImpression: this.minPerImpression,
        rules: this.rules,
        rulesInput: this.rulesInput,
        website: this.website,
        created: this.created ? new Date(this.created).getTime() : Date.now()
      });
    }
  }, {
    key: "marketDbAdd",
    get: function get() {
      return this.deepCopyObj({
        id: this.ipfs,
        ipfs: this.ipfs,
        owner: this.owner,
        type: this.type,
        tags: this.tags,
        autoTags: this.autoTags,
        title: this.title,
        description: this.description,
        fallbackUnit: this.fallbackUnit,
        rules: this.rules,
        rulesInput: this.rulesInput,
        minPerImpression: this.minPerImpression,
        website: this.website,
        created: this.created,
        archived: this.archived,
        modified: this.modified
      });
    }
  }, {
    key: "marketDbUpdate",
    get: function get() {
      return this.deepCopyObj({
        title: this.title,
        description: this.description,
        fallbackUnit: this.fallbackUnit,
        rules: this.rules,
        rulesInput: this.rulesInput,
        minPerImpression: this.minPerImpression,
        website: this.website,
        archived: this.archived,
        modified: this.modified
      });
    }
  }, {
    key: "marketAdUnitAdd",
    get: function get() {
      return new AdUnit({
        type: this.type,
        mediaUrl: this.mediaUrl,
        mediaMime: this.mediaMime,
        targetUrl: this.targetUrl,
        targeting: [],
        tags: [],
        autoTags: [],
        owner: this.owner,
        created: this.created ? new Date(this.created).getTime() : Date.now()
      });
    }
  }, {
    key: "marketUpdate",
    get: function get() {
      return this.deepCopyObj({
        title: this.title,
        description: this.description,
        fallbackUnit: this.fallbackUnit,
        rules: this.rules,
        rulesInput: this.rulesInput,
        minPerImpression: this.minPerImpression,
        website: this.website,
        archived: this.archived
      });
    }
  }]);

  return AdSlot;
}(Base);

module.exports = AdSlot;